var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dataSource.length > 0
    ? _c(
        "div",
        [
          _c("label", [_vm._v(_vm._s(_vm.$t("history")))]),
          _vm._v(" "),
          _c("HKLTable", {
            staticClass: "green-fitout__sub-folders-histories",
            attrs: {
              columns: _vm.columns,
              dataSource: _vm.dataSource,
              onSort: false,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }